import { useState, useEffect } from "react";
import { checkAdminAccessApi } from "../api";
import { getIdToken } from "../authConfig";

export const useAdminCheck = () => {
    const [isAdminUser, setIsAdminUser] = useState<boolean>(false);
    const [isCheckingAdmin, setIsCheckingAdmin] = useState<boolean>(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                setIsCheckingAdmin(true);
                const idToken = await getIdToken();
                if (!idToken) {
                    console.warn("⚠️ No ID token found for admin check.");
                    return;
                }

                const isAdmin = await checkAdminAccessApi(idToken);
                setIsAdminUser(isAdmin);
            } catch (error) {
                console.error("Error while checking admin access:", error);
            } finally {
                setIsCheckingAdmin(false);
            }
        };

        checkAdminStatus();
    }, []);

    return { isAdminUser, isCheckingAdmin };
};
